import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/data-access/src/lib/QueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/model/src/lib/error-with-friendly-message/error-with-friendly-message.ts");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/auth/src/lib/auth-provider-context/auth-provider-context.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/auth/src/lib/auth-provider-context/AuthProviderContextProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/auth/src/lib/auth-provider-context/use-auth-provider-context.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/auth/src/lib/auth-provider/AuthProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/auth/src/lib/logout/Logout.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/auth/src/lib/with-authentication/WithAuthentication.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/next-js/common/ui/theme/src/lib/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/shared/common/feature/datadog-rum/src/lib/DatadogRum.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/shared/common/feature/datadog-rum/src/lib/use-set-user.ts");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/shared/common/feature/feature-flags/src/lib/FeatureFlagsProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/shared/common/feature/feature-flags/src/lib/use-feature-flag-on/use-feature-flag-on.ts");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/shared/common/feature/feature-flags/src/lib/use-feature-flag/use-feature-flag.ts");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/libs/shared/common/ui/heap-rum/src/lib/HeapAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"],\"variable\":\"--font-roboto\",\"weight\":[\"400\",\"500\",\"700\"]}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/@moodys-bss/reset-css/reset.css");
